<template>
  <Modal :active="active" :vehicle="vehicle" :title="$t('forms.callMeBack.title')" @modalClosed="closeModal" ref="modal">
    <div class="form-modal-intro">
      <div v-if="introText" v-html="introText"></div>
    </div>

    <p v-if="successMsg" class="form-success">{{ successMsg }}</p>
    <p v-if="errorMsg" class="form-error">{{ errorMsg }}</p>

    <form id="request-callback" @submit.prevent="submitForm($event)" @change="validateErrorFields">
      <p v-if="errors.length > 0" class="form-error">{{ $t('forms.errors.requiredFields') }}</p>

      <div class="formRow">
        <div class="formRow__label">
          <label class="form-label" for="testRide-fullName">{{ $t('forms.fields.fullName') }}</label>
        </div>
        <!-- .formRow__label -->
        <div class="formRow__field">
          <input
            id="testRide-fullName"
            class="form-textField"
            :class="{ 'form-textField--error': isError('fullName') }"
            type="text"
            v-model="fullName"
          />
          <p v-if="isError('fullName')" class="form-fieldError">{{ $t('forms.errors.requiredFieldSingle') }}</p>
        </div>
        <!-- .formRow__field -->
      </div>
      <!-- .formRow -->

      <div class="formRow">
        <div class="formRow__label">
          <label class="form-label" for="testRide-phoneNumber">{{ $t('forms.fields.phone') }}</label>
        </div>
        <!-- .formRow__label -->
        <div class="formRow__field">
          <input
            id="testRide-phoneNumber"
            class="form-textField"
            :class="{ 'form-textField--error': isError('phoneNumber') }"
            type="text"
            v-model="phoneNumber"
          />
          <p v-if="isError('phoneNumber')" class="form-fieldError">{{ $t('forms.errors.requiredFieldSingle') }}</p>
        </div>
        <!-- .formRow__field -->
      </div>
      <!-- .formRow -->

      <div class="formRow formRow--spaced">
        <div class="formRow__field formRow__field--noLabel">
          <div class="form-checkbox">
            <input id="testRide-acceptTerms" class="form-checkbox__input" type="checkbox" v-model="acceptTerms" />
            <label class="form-checkbox__label" for="testRide-acceptTerms">
              <span
                >{{ $t('forms.fields.acceptTermsPre') }} <a :href="termsUrl" target="_blank">{{ $t('forms.fields.terms') }}</a></span
              >
            </label>
            <p v-if="isError('acceptTerms')" class="form-fieldError form-fieldError--spaced">{{ $t('forms.errors.acceptTerms') }}</p>
          </div>
          <!-- .form-checkbox -->
        </div>
        <!-- .formRow__field -->
      </div>
      <!-- .formRow -->

      <div class="formRow formRow--spaced">
        <div class="formRow__field formRow__field--noLabel">
          <input
            type="submit"
            class="button button--primary button--arrow button--submit"
            :class="{ 'button--loading': loading }"
            :disabled="loading"
            :value="$t('forms.callMeBack.submit')"
          />
        </div>
        <!-- .formRow__field -->
      </div>
      <!-- .formRow -->
    </form>
  </Modal>
</template>

<script>
import { WPSettings } from '@/WPSettings'
import axios from 'axios'
import Modal from '@/components/Modal'

export default {
  name: 'modalTestRide',
  data() {
    return {
      loading: false,
      errors: [],
      errorMsg: '',
      successMsg: '',
      fullName: '',
      phoneNumber: '',
      acceptTerms: false,
      termsUrl: this.$store.state.settings.general.termsUrl,
    }
  },
  props: ['active', 'introText', 'vehicle'],
  components: {
    Modal,
  },
  computed: {
    currentVehicleId() {
      const currentVehicle = this.$store.getters['vehicles/current']
      return currentVehicle ? currentVehicle.id : null
    },
  },
  methods: {
    closeModal() {
      // Emit to parent component
      this.$emit('modalClosed', true)

      // Reset errors - just because it's prettier
      this.errors = []
    },

    isError(field) {
      // Check if field is in the error list
      return this.errors.includes(field)
    },

    validateErrorFields() {
      // Re-check the error fields
      if (this.errors.length > 0) {
        this.errors.forEach((error) => {
          if (this[error]) {
            // Field has a value, so remove it from the error list
            this.errors = this.errors.filter((el) => el !== error)
          }
        })
      }
    },

    validateForm() {
      // Reset errors
      this.errors = []

      // Fields to check
      const checkIfHasValue = ['fullName', 'phoneNumber', 'acceptTerms']

      // Check fields
      checkIfHasValue.forEach((field) => {
        if (!this[field]) {
          // Field has no value, so add it to error list
          this.errors.push(field)
        }
      })
    },

    submitForm(e) {
      // Prevent form from being submitted by browser
      e.preventDefault()

      // Validate form
      this.validateForm()

      // If there are any errors, stop here
      if (this.errors.length > 0) {
        return false
      }

      // Do the call to WP REST
      this.loading = true

      axios
        .post(
          WPSettings.API_URL + '/form-call-me-back',
          {
            vehicleId: this.currentVehicleId,
            fullName: this.fullName,
            phoneNumber: this.phoneNumber,
          },
          {
            headers:
              process.env.NODE_ENV === 'production'
                ? {
                    'X-WP-Nonce': WPSettings.NONCE,
                  }
                : {},
          }
        )
        .then((response) => {
          if (response.data.status === 'success') {
            // Update success message
            this.errorMsg = ''
            this.successMsg = response.data.message

            // Reset form
            this.fullName = this.phoneNumber = this.acceptTerms = ''
          }
        })
        .catch((error) => {
          if (error.response.data.status === 'error') {
            // Update error message
            this.successMsg = ''
            this.errorMsg = error.response.data.message
          } else {
            this.successMsg = ''
            this.errorMsg = this.$t('forms.errors.somethingWentWrong')
          }
        })
        .finally(() => (this.loading = false))
    },
  },
}
</script>
